// @flow
import { EventsContactsActionTypes } from './constants';

type EventsContactsAction = { type: string, payload: {} | string };

// common success
export const eventsContactsApiResponseSuccess = (actionType: string, data: any): EventsContactsAction => ({
    type: EventsContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const eventsContactsApiResponseError = (actionType: string, error: string): EventsContactsAction => ({
    type: EventsContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getEventContact = (id: string): EventsContactsAction => ({
    type: EventsContactsActionTypes.GET_EVENTS_CONTACTS,
    payload: { id },
});

export const addEventsContact = (eventoContacto:any):EventsContactsAction=>({
    type:EventsContactsActionTypes.ADD_EVENTS_CONTACTS,
    payload:eventoContacto
})
export const updateEventsContact = (eventoContacto:any):EventsContactsAction=>({
    type:EventsContactsActionTypes.UPDATE_EVENTS_CONTACTS,
    payload:eventoContacto
})
export const deleteEventsContact = (id:string):EventsContactsAction=>({
    type:EventsContactsActionTypes.DELETE_EVENTS_CONTACTS,
    payload:{id}
})

export const listEventsContacts = (params:any): EventsContactsAction => ({
    type: EventsContactsActionTypes.LIST_EVENTS_CONTACTS,
    payload: params,
});


export const resetEventsContacts = (): EventsContactsAction => ({
    type: EventsContactsActionTypes.RESET,
    payload: {},
});

